import React, { useEffect, useRef } from "react";
import clsx from "clsx";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import MobileContainer from "./Level1";
import useFocusTrap from "../../../../../hooks/useFocusTrap";
import Lang from "../../Lang";
import Links from "../Links";
import SocialMediaIcons from "../../../SocialMediaIcons";

import styles from "./MobileMenu.styles";

const MobileMenu = ({ menuGroup, setMenuOpen }) => {
	const css = styles();
	const { items } = menuGroup;
	const header = document.querySelector(".mco-view-component-header__container");
	const ref = useRef(null);
	const { focusTrigger, trapRef } = useFocusTrap(true, [header]);

	useEffect(() => {
		const handleKeyDown = event => {
			if (event.key === "Escape") {
				focusTrigger();
				setMenuOpen(false);
			}
		};

		disableBodyScroll(ref.current);
		window.addEventListener("keydown", handleKeyDown);

		return () => {
			clearAllBodyScrollLocks();
			window.removeEventListener("keydown", handleKeyDown);
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div
			className={clsx(css.mobilemenu, "mco-view-component-header-menu-mobilemenu")}
			ref={ref}
		>
			<div
				className={clsx(css.container, "mco-view-component-header-menu-mobilemenu__container")}
				ref={trapRef}
			>
				<MobileContainer items={items} />
				<div
					className={clsx(css.divider, "mco-view-component-header-menu-mobilemenu__divider")}
				>
					<Lang />
					<SocialMediaIcons />
				</div>
				<div className={clsx(css.links, "mco-view-component-header-menu-mobilemenu__links")}>
					<Links />
				</div>
			</div>
		</div>
	);
};

export default MobileMenu;
